/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_NetworkInputs */

const vi_file_upload_error_network = /** @type {(inputs: File_Upload_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gửi được tệp lên máy chủ. Kiểm tra kết nối mạng rồi thử lại.`)
};

/**

* @param {File_Upload_Error_NetworkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_network = /** @type {((inputs?: File_Upload_Error_NetworkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_NetworkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_network(inputs)
});